<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    :fill="iconColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.7 9.4C3.38781 9.4 3.0925 9.47875 2.83656 9.61937C2.94906 8.58719 3.30906 7.68437 3.80687 7.02062C4.41156 6.21625 5.17937 5.8 5.95 5.8C6.72062 5.8 7.48844 6.21625 8.09312 7.02062C8.69781 7.82781 9.1 8.98375 9.1 10.3C9.1 11.6162 8.69781 12.7722 8.09312 13.5794C7.48844 14.3866 6.72062 14.8 5.95 14.8C5.17937 14.8 4.41156 14.3837 3.80687 13.5794C3.66906 13.3966 3.5425 13.1969 3.43 12.9803C3.51719 12.9944 3.61 13 3.7 13C4.69281 13 5.5 12.1928 5.5 11.2C5.5 10.2072 4.69281 9.4 3.7 9.4ZM10 6.66344C9.85938 6.4075 9.70469 6.16844 9.53312 5.94062C8.6725 4.79312 7.41531 4 5.95 4C4.48469 4 3.2275 4.79312 2.36687 5.94062C1.50625 7.08812 1 8.63219 1 10.3C1 11.9678 1.50625 13.5119 2.36687 14.6594C3.2275 15.8069 4.48469 16.6 5.95 16.6C7.41531 16.6 8.6725 15.8069 9.53312 14.6594C9.70187 14.4344 9.85938 14.1925 10 13.9366C10.1406 14.1925 10.2953 14.4316 10.4669 14.6594C11.3275 15.8069 12.5847 16.6 14.05 16.6C15.5153 16.6 16.7725 15.8069 17.6331 14.6594C18.4937 13.5119 19 11.9678 19 10.3C19 8.63219 18.4937 7.08812 17.6331 5.94062C16.7725 4.79312 15.5153 4 14.05 4C12.5847 4 11.3275 4.79312 10.4669 5.94062C10.2981 6.16562 10.1406 6.4075 10 6.66344ZM11.53 12.9803C11.6172 12.9944 11.71 13 11.8 13C12.7928 13 13.6 12.1928 13.6 11.2C13.6 10.2072 12.7928 9.4 11.8 9.4C11.4878 9.4 11.1925 9.47875 10.9366 9.61937C11.0491 8.58719 11.4091 7.68437 11.9069 7.02062C12.5116 6.21625 13.2794 5.8 14.05 5.8C14.8206 5.8 15.5884 6.21625 16.1931 7.02062C16.7978 7.82781 17.2 8.98375 17.2 10.3C17.2 11.6162 16.7978 12.7722 16.1931 13.5794C15.5884 14.3866 14.8206 14.8 14.05 14.8C13.2794 14.8 12.5116 14.3837 11.9069 13.5794C11.7691 13.3966 11.6425 13.1969 11.53 12.9803Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script setup>
defineProps({
  width: {
    type: [Number, String],
    required: false,
    default: 24
  },
  height: {
    type: [Number, String],
    required: false,
    default: 24
  },
  iconColor: {
    type: String,
    required: false,
    default: '#232323'
  }
})
</script>
